const DEBUG_KEY = "debug";

export function isDebugMode(): boolean {
    if (typeof window === "undefined") return false;
    try {
        return window.localStorage.getItem(DEBUG_KEY) === "true";
    } catch {
        return false;
    }
}
